import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8xjhax5kfk: FaireBrandEntity = {
  token: "b_8xjhax5kfk",
  type: "brand",
  name: "Field Day",
  avatarUrl: "https://cdn.faire.com/fastly/a09a64e28523d19825c1a5961f34accc8619b8e6589b4814021f7e096f114c1d.png",
  bannerUrl: "https://cdn.faire.com/fastly/4e1cbf78c7eba49bf9e99758426b9ac9b25080b27c40f6ec02e8571e21cdde75.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/a09a64e28523d19825c1a5961f34accc8619b8e6589b4814021f7e096f114c1d.png",
  heroImageUrl: "https://cdn.faire.com/fastly/4e1cbf78c7eba49bf9e99758426b9ac9b25080b27c40f6ec02e8571e21cdde75.jpeg",
  location: "Oakland, CA, USA",
  minimumOrderDollars: 500,
  rating: 5,
  reviewCount: 1,
  isTopShop: true,
  isInsider: true,
  description: "Field Day emerged from the desire to make timeless, impeccably crafted clothing from completely conscious materials that transcend trendy and were made to make history.\n\nWe design for the women who inspire us. Women who like the feeling of earth between their fingers. Cool winter breezes and hot summer river dips. Who aren’t afraid to strike out on their own, and dress for uncharted days of spontaneous adventures.\n\nWe want you to feel good about what you wear.  Field Day designs are flattering, comfortable, and made from reclaimed and locally-sourced materials.  Our entire line is designed, cut, sewn, dyed and finished in Oakland, CA.  We believe in tailored clothing you can move and breathe in, and that no dress is complete without pockets. Founder Trinity Cross has been designing our classic silhouettes for the modern woman since establishing field day in 2005. \n\nNow based in the Sierra foothills\nVisit our showroom & Boutique \n\nField Day \n408 Broad Street \nNevada City CA 95959",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:03.005Z",
    importedBy: "entity-db-cli"
  }
};
